import { render, staticRenderFns } from "./ChosenProductsList.vue?vue&type=template&id=12329597&scoped=true"
import script from "./ChosenProductsList.vue?vue&type=script&lang=js"
export * from "./ChosenProductsList.vue?vue&type=script&lang=js"
import style0 from "./ChosenProductsList.vue?vue&type=style&index=0&id=12329597&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12329597",
  null
  
)

export default component.exports